export const BLOCKED_STEP = "blocked";
export const WARNING_STEP = "warning";
